import React from "react";
import { inject, observer } from "mobx-react";
import { RouterView } from "mobx-state-router";
import AccountCreationProjectPage from "routes/AccountCreationProjectPage";
import PostingProjectPage from "routes/PostingProjectPage";
import IndexerProjectPage from "routes/IndexerProjectPage";
import PrivateProjectPage from "routes/PrivateProjectPage";
import CampaignsPage from "routes/CampaignsPage";
import ContentGroupsPage from "routes/ContentGroupsPage";
import ContentGroupPage from "routes/ContentGroupPage";
import ArticlePage from "routes/ArticlePage";
import LoginPage from "routes/LoginPage";
import OptionsPage from "routes/OptionsPage";
import CampaignPage from "routes/CampaignPage";
import AccountsPage from "routes/AccountsPage";
import PrivateNetworksPage from "routes/PrivateNetworksPage";
import PrivateNetworkPage from "routes/PrivateNetworkPage"
import LinksPage from "routes/LinksPage";
import XWizardPage from "routes/XWizardPage";
import XWizardsPage from "routes/XWizardsPage";
import StrategyDesigner from "routes/StrategyDesigner";
import StrategiesPage from "routes/StrategiesPage";
import EmailManangerPage from "routes/EmailManagerPage";
import CloudAccountsPage from "routes/CloudAccountsPage"
import SiteSelectionsPage from "routes/SiteSelectionsPage";
import SiteSelectionPage from "routes/SiteSelectionPage";
import CustomSitesPage from "routes/CustomSitesPage";
import BasicLayout from "layouts/BasicLayout";
import CloudBlogGeneratorPage from "routes/CloudBlogGeneratorPage";

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	componentDidCatch(error, info) {
		// Display fallback UI
		this.setState({ hasError: true });
		// You can also log the error to an error reporting service
		//logErrorToMyService(error, info);
		console.log(error);
	}

	render() {
		if (this.state.hasError) {
			// You can render any custom fallback UI
			return <h1>Something went wrong.</h1>;
		}
		return this.props.children;
	}
}

const viewMap = {
	acProject: <AccountCreationProjectPage />,
	postingProject: <PostingProjectPage />,
	indexerProject: <IndexerProjectPage />,
	privateProject: <PrivateProjectPage />,
	campaigns: <CampaignsPage />,
	campaign: <CampaignPage />,	
	login: <LoginPage />,
	options: <OptionsPage />,
	accounts: <AccountsPage />,
	links: <LinksPage />,
	xwizard: <XWizardPage />,
	xwizards: <XWizardsPage />,
	newcampaign: <XWizardPage />,
	newWizard: <XWizardPage />,	
	duplicatecampaign: <XWizardPage />,
	strategy: <StrategyDesigner />,
	strategies: <StrategiesPage />,
	contentGroups: <ContentGroupsPage />,
	contentGroup: <ContentGroupPage />,
	siteSelections: <SiteSelectionsPage />,
	article: <ArticlePage />,
	newArticle: <ArticlePage />,
	privateNetworks: <PrivateNetworksPage />,
	privateNetwork: <PrivateNetworkPage />,
	emailManager: <EmailManangerPage />,
	siteSelection: <SiteSelectionPage />,
	customSites: <CustomSitesPage />,
	cloudAccounts: <CloudAccountsPage />,
	cloudBlogGenerator: <CloudBlogGeneratorPage />
};

@observer
class ShellBase extends React.Component {
	render() {
		const {
			rootStore: { routerStore }
		} = this.props;

		let routerState = routerStore.routerState;
		if (routerState.routeName == "login") {
			return <RouterView routerStore={routerStore} viewMap={viewMap} />
		} else {
			return (
				<BasicLayout>
					<RouterView routerStore={routerStore} viewMap={viewMap} />
				</BasicLayout>
			);
		}
	}
}

export const Shell = inject("rootStore")(ShellBase);
